import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateFunnelMapName } from '../../reducers/united-canvas/unitedCanvasReducer';

/**
 * Hook for renaming the current funnel map to "Dental Patient Management"
 * This is used in the Dreamforce demo to provide a professional name for the healthcare scenario
 * Uses Redux action to update the name, which will be picked up by auto-save
 */
export const useRenameFunnelMapToDental = () => {
  const dispatch = useDispatch();

  const renameToDentalPatientManagement = useCallback(async () => {
    try {
      console.log('🎯 Demo: Renaming funnel map to "Dental Patient Management"...');
      
      // Update the name in Redux state - auto-save will handle the API call
      dispatch(updateFunnelMapName('Dental Patient Management'));

      console.log('🎯 Demo: Successfully updated funnel map name in Redux state');
    } catch (error) {
      console.error('🎯 Demo: Failed to rename funnel map:', error);
      throw error;
    }
  }, [dispatch]);

  return { renameToDentalPatientManagement };
};
